<script setup>
import { reactiveOmit } from '@vueuse/core';
import { DatePickerCellTrigger, useForwardProps } from 'reka-ui';
import { cn } from '@/lib/utils';
import { buttonVariants } from '@/Components/ui/button';

const props = defineProps({
    day: { type: null, required: true },
    month: { type: null, required: true },
    asChild: { type: Boolean, required: false },
    as: { type: null, required: false },
    class: { type: null, required: false },
});

const delegatedProps = reactiveOmit(props, 'class');

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
    <DatePickerCellTrigger
        :class="
            cn(
                buttonVariants({ variant: 'ghost' }),
                'h-8 w-8 !rounded-full p-0 font-normal',
                '[&[data-today]:not([data-selected])]:border-2 [&[data-today]:not([data-selected])]:border-accent',
                // Selected
                'data-[selected]:text-primary-foreground data-[selected]:hover:text-primary-foreground data-[selected]:focus:text-primary-foreground data-[selected]:bg-primary data-[selected]:opacity-100 data-[selected]:hover:bg-primary data-[selected]:focus:bg-primary',
                // Disabled
                'data-[disabled]:text-muted-foreground data-[disabled]:opacity-50',
                // Unavailable
                'data-[unavailable]:text-destructive-foreground data-[unavailable]:line-through',
                // Outside months
                'data-[outside-view]:text-muted-foreground [&[data-outside-view][data-selected]]:text-muted-foreground data-[outside-view]:opacity-50 [&[data-outside-view][data-selected]]:bg-accent/50 [&[data-outside-view][data-selected]]:opacity-30',
                props.class,
            )
        "
        v-bind="forwardedProps"
    >
        <slot />
    </DatePickerCellTrigger>
</template>
